import { render, staticRenderFns } from "./StandardizationCommittee.vue?vue&type=template&id=494315f7"
import script from "./StandardizationCommittee.vue?vue&type=script&lang=js"
export * from "./StandardizationCommittee.vue?vue&type=script&lang=js"
import style0 from "./StandardizationCommittee.vue?vue&type=style&index=0&id=494315f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports